import { render } from "./ConfigsModifiedView.vue?vue&type=template&id=6aa95945&scoped=true"
import script from "./ConfigsModifiedView.vue?vue&type=script&lang=js"
export * from "./ConfigsModifiedView.vue?vue&type=script&lang=js"

import "./ConfigsModifiedView.vue?vue&type=style&index=0&id=6aa95945&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa95945"]])

export default __exports__